// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__TnsD9","disappear":"Preloader_disappear__Y-1eK","animation_area":"Preloader_animation_area__dUm2a","move":"Preloader_move__Y+3lr"};